// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"e_Wp","popupBlock":"e_Xp"};